import { wsService } from "./wsService";

const section = "shipment-orders";

const STATUS_PENDIENTE_PREPARACION = "PEN";
const STATUS_STOCK_RESERVADO = "STR";
const STATUS_EN_PREPARACION = "EPR";
const STATUS_PREPARADO = "PRE";
const STATUS_EMPAQUETADO = "EMP";
const STATUS_DESPACHADO = "DES";
const STATUS_CONTROLADO = "CON";
const STATUS_EXPEDIDO = "EXP";
const STATUS_CANCELADO = "CAN";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function list_status() {
  return wsService.make_get_request(section + "/list_status");
}

function get(param = { enable: true }) {
  return wsService.make_post_request(section + "/get", param);
}

function generatePickingDetail(param = {}) {
  return wsService.make_post_request(section + "/reserve", param);
}

function create_wave(param = {}) {
  return wsService.make_post_request(section + "/create-wave", param);
}
function assign_wave(param = {}) {
  return wsService.make_post_request(section + "/assign-wave", param);
}

function assign_dock(param = {}) {
  return wsService.make_post_request(section + "/assign-dock", param);
}

function delete_wave(param = {}) {
  return wsService.make_post_request(section + "/delete-wave", param);
}

function cancel_reserve(param = {}) {
  return wsService.make_post_request(section + "/cancel-reserve", param);
}

function cancel_shipment(param = {}) {
  return wsService.make_post_request(section + "/cancel-shipment", param);
}

function get_historial(param = {}) {
  return wsService.make_post_request(section + "/get-historial", param);
}

function shiped(param = {}) {
  return wsService.make_post_request(section + "/shiped", param);
}

function get_lpns(param = {}) {
  return wsService.make_post_request(section + "/get-lpns", param);
}

function getStatusName(estado) {
  switch (estado) {
    case STATUS_PENDIENTE_PREPARACION:
      return "Pendiente de reserva";
    case STATUS_STOCK_RESERVADO:
      return "Pendiente de preparación";
    case STATUS_EN_PREPARACION:
      return "En preparación";
    case STATUS_PREPARADO:
      return "Preparado";
    case STATUS_EMPAQUETADO:
      return "Empaquetado";
    case STATUS_CONTROLADO:
      return "Controlado";
    case STATUS_EXPEDIDO:
      return "Expedido";
    case STATUS_CANCELADO:
      return "Cancelado";
    default:
      return "Desconocido";
  }
}

function print_remito(shipment_order_id) {
  return wsService.make_post_request(
    section + "/print_remito/" + shipment_order_id,
    {},
    {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    }
  );
}

function print_remito_preimpreso(shipment_order_id) {
  return wsService.make_post_request(
    section + "/print_remito_preimpreso/" + shipment_order_id,
    {},
    {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    }
  );
}

function sync_shipment_in_tms(shipment_order_id) {
  return wsService.make_post_request(section + "/sync-shipment-in-tms", { shipment_order_id });
}

function download_excel(param = {}) {
  return wsService.make_post_request(section + "/get-sample-excel", param);
}

function import_line_excel(param = {}) {
  return wsService.make_post_request(section + "/import-line", param);
}

function getSubStatusName(subStatus) {
  switch (subStatus) {
    case 'RC':
      return 'Reserva completa';
    case 'RP':
      return 'Reserva parcial';
    default:
      return '';
  }
}

function assignPickingUser(param = {}) {
  return wsService.make_post_request(section + "/assign-picking-user", param);
}

function unassignPickingUser(param = {}) {
  return wsService.make_post_request(section + "/unassign-picking-user", param);
}

function distributePickingAutomatically(param = {}) {
  return wsService.make_post_request(section + "/distribute-picking-automatically", param);
}

export const shipmentOrderService = {
  STATUS_PENDIENTE_PREPARACION,
  STATUS_STOCK_RESERVADO,
  STATUS_EN_PREPARACION,
  STATUS_PREPARADO,
  STATUS_EMPAQUETADO,
  STATUS_DESPACHADO,
  STATUS_CONTROLADO,
  STATUS_EXPEDIDO,
  STATUS_CANCELADO,

  section,
  filter,
  remove,
  create,
  update,
  get,
  close,
  list_status,
  generatePickingDetail,
  create_wave,
  assign_wave,
  delete_wave,
  cancel_reserve,
  cancel_shipment,
  assign_dock,
  get_historial,
  getStatusName,
  print_remito,
  print_remito_preimpreso,
  shiped,
  sync_shipment_in_tms,
  get_lpns,
  download_excel,
  import_line_excel,
  getSubStatusName,
  assignPickingUser,
  unassignPickingUser,
  distributePickingAutomatically
};
